exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.living-title[data-v-2236bf1c]{padding:0.2rem 0.37rem\n}\n.living-title h5[data-v-2236bf1c]{margin-bottom:0.24rem;font-size:0.37rem\n}\n.living-title p[data-v-2236bf1c]{color:#666666;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.living-title p img[data-v-2236bf1c]{margin-right:0.1rem\n}\n", ""]);

// exports
